var _g, _path, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_885_2698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.227 135.549L239.996 124.825L229.271 114.057L196.291 80.9728C195.683 80.3433 194.685 80.2781 194.033 80.8426C191.45 82.9701 188.171 84.2075 184.719 84.2075C179.487 84.2075 174.667 81.4287 172.062 76.9132C169.456 72.3977 169.456 66.7968 172.062 62.303C172.452 61.63 172.887 61.0004 173.364 60.3926C173.994 59.6328 173.929 58.5039 173.234 57.8092L140.32 24.768L129.594 14.0002L118.826 24.7245L30.7649 112.451L19.9961 123.175L30.7214 133.943L119.672 223.233L130.398 234L141.167 223.276L173.516 191.038C175.231 192.623 177.316 193.817 179.661 194.446C184.698 195.792 190.082 194.359 193.773 190.669C197.464 186.978 198.897 181.594 197.551 176.558C196.921 174.235 195.749 172.173 194.164 170.458H194.185L229.206 135.549H229.227Z",
    fill: "#0321F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.853 135.195L193.979 169.958H193.021L193.796 170.797C195.329 172.455 196.46 174.446 197.068 176.688C198.367 181.553 196.983 186.752 193.419 190.315C189.855 193.879 184.655 195.263 179.79 193.963C177.527 193.356 175.514 192.203 173.856 190.671L173.503 190.345L173.163 190.684L140.814 222.922L140.814 222.922L130.399 233.293L120.027 222.88L31.0757 133.59L20.7032 123.177L31.1177 112.805L31.1177 112.805L119.178 25.0788L119.179 25.0788L129.593 14.7073L139.966 25.1208L140.32 24.768L139.966 25.1208L172.88 58.1621L172.88 58.1628C173.396 58.6787 173.441 59.5165 172.979 60.0736L172.979 60.0735L172.971 60.0837C172.481 60.7079 172.033 61.3567 171.629 62.0519L171.629 62.0522C168.934 66.7015 168.934 72.4933 171.629 77.1631C174.324 81.8339 179.309 84.7075 184.719 84.7075C188.292 84.7075 191.681 83.427 194.351 81.2285L194.351 81.2287L194.361 81.2204C194.801 80.8392 195.498 80.8714 195.932 81.3202L195.937 81.3258L228.916 114.41L228.917 114.41L239.289 124.824L229.021 135.049H228.999L228.853 135.195Z",
    stroke: "#0FF0DB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.505 124.782L173.129 170.002L130.445 212.508L41.4937 123.219L129.554 35.4922L165.009 71.0734L218.505 124.782Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.841 76.8912L122.431 154.653C121.932 156.694 123.17 158.756 125.21 159.277L177.665 172.368C179.706 172.867 181.768 171.63 182.289 169.589L201.938 93.1947C202.633 90.4811 200.983 87.724 198.269 87.0293L146.444 74.0907C144.403 73.5914 142.341 74.8288 141.82 76.8695L141.841 76.8912Z",
    fill: "white",
    stroke: "#0321F8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_885_2698",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 139,
    y: 93,
    width: 51,
    height: 53
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.176 93.6403L139.542 136.072L178.861 145.926L189.495 103.495L150.176 93.6403Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_885_2698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.646 123.523L151.023 117.856C149.677 117.531 148.331 118.334 148.005 119.68L144.249 134.681C143.923 136.027 144.727 137.373 146.073 137.72L168.696 143.386C170.042 143.712 171.388 142.909 171.736 141.563L175.492 126.562C175.817 125.216 175.014 123.87 173.668 123.523H173.646Z",
    fill: "#0321F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.084 133.726L177.835 141.78C178.551 142.518 179.789 142.171 180.049 141.194L182.937 129.709C183.176 128.711 182.242 127.843 181.265 128.146L170.648 131.598C169.715 131.902 169.432 133.031 170.106 133.747L170.084 133.726Z",
    fill: "#0321F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.021 115.49C160.384 116.836 165.812 113.58 167.158 108.218C168.504 102.855 165.247 97.4282 159.884 96.0822C154.522 94.7363 149.094 97.9926 147.748 103.355C146.402 108.717 149.658 114.144 155.021 115.49Z",
    fill: "#0321F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.274 120.071C178.637 121.417 184.065 118.16 185.411 112.798C186.757 107.436 183.5 102.009 178.137 100.663C172.775 99.3169 167.347 102.573 166.001 107.935C164.655 113.298 167.911 118.725 173.274 120.071Z",
    fill: "#0321F8"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.736 160.645H157.34C159.294 160.645 160.879 159.06 160.879 157.106V76.4137C160.879 74.4599 159.294 72.8751 157.34 72.8751H102.736C100.782 72.8751 99.1973 74.4599 99.1973 76.4137V157.106C99.1973 159.06 100.782 160.645 102.736 160.645Z",
    fill: "white",
    stroke: "#0321F8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.211 146.99H119.476C117.587 146.99 116.024 145.557 115.85 143.69L113.701 120.288C113.505 118.16 115.177 116.315 117.326 116.315H141.361C143.51 116.315 145.182 118.16 144.986 120.288L142.837 143.69C142.663 145.557 141.1 146.99 139.211 146.99Z",
    fill: "#0321F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M146.05 115.338H111.312V119.68H146.05V115.338Z",
    fill: "#0321F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.133 116.293L119.368 106.437C120.128 104.136 122.277 102.573 124.709 102.573H133.871C136.324 102.573 138.495 104.158 139.234 106.481L142.338 116.228C142.338 116.228 124.036 122.632 116.133 116.271V116.293Z",
    fill: "#0321F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.336 99.7726C133.244 99.7726 136.414 96.6031 136.414 92.6954C136.414 88.7878 133.244 85.6183 129.336 85.6183C125.428 85.6183 122.258 88.7878 122.258 92.6954C122.258 96.6031 125.428 99.7726 129.336 99.7726Z",
    fill: "#0321F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132.354 120.939L129.792 122.98C129.488 123.218 129.076 123.197 128.793 122.98L126.449 120.961C126.253 120.787 126.167 120.548 126.188 120.288L127.556 105.352C128.707 104.701 129.879 104.722 131.051 105.352L132.636 120.266C132.636 120.526 132.549 120.787 132.354 120.961V120.939Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5954 173.605L133.811 159.538C135.852 158.995 137.046 156.911 136.503 154.87L115.639 77.4775C115.096 75.4369 113.012 74.2429 110.971 74.7856L58.7552 91.2194C56.7143 91.7621 55.5202 93.8462 56.063 95.8869L76.9275 170.935C77.4702 172.976 79.5545 174.17 81.5954 173.627V173.605Z",
    fill: "white",
    stroke: "#0321F8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_885_2698",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 97,
    width: 40,
    height: 54
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M115.663 97.9708H76.583V150.073H115.663V97.9708Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_885_2698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.643 130.274C109.54 141.215 100.074 148.445 89.4353 149.986C86.6345 150.398 83.8121 149.183 82.1837 146.816C76.5171 138.632 74.8453 127.821 78.6231 117.748C82.7048 106.828 92.1926 99.599 102.809 98.0577C105.61 97.6452 108.433 98.8609 110.061 101.206C115.728 109.39 117.421 120.223 113.643 130.296V130.274Z",
    fill: "#0321F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3545 121.395L102.902 126.67",
    stroke: "white",
    strokeWidth: 7.5974,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7842 112.212L106.354 117.488",
    stroke: "white",
    strokeWidth: 7.5974,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9004 130.578L99.4482 135.854",
    stroke: "white",
    strokeWidth: 7.5974,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_885_2698",
    x: -0.00390625,
    y: 0.000244141,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.18767 0 0 0 0 0.926514 0 0 0 0 0.837852 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_885_2698"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_885_2698",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCategories);
export default __webpack_public_path__ + "static/media/empty-categories.955ac8a2a4fdd004c11d416eb51717f8.svg";
export { ForwardRef as ReactComponent };